/**
 * Subscribe to live Firestore changes of a user media by id.
 * Mirrors Flutter's user_details_screen.dart:_listenToMediaLiveChanges.
 */

import { UserMediaService } from '@/domain/services/userMedia/userMediaService';
import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';
import { RemoteDocumentChangeType } from '@/data/types/remoteDocumentChangeType';
import type { Unsubscribe } from 'firebase/firestore';

export class SubscribeToUserMediaLiveChangesUseCase {
  constructor(private service = UserMediaService.getInstance()) {}

  execute(
    userId: string,
    mediaId: string,
    onChange: (change: { type: RemoteDocumentChangeType; media: UserMediaEntity }) => void,
  ): Unsubscribe {
    return this.service.subscribeToUserMediaLiveChanges(userId, mediaId, onChange);
  }
}

export const subscribeToUserMediaLiveChangesUseCase = new SubscribeToUserMediaLiveChangesUseCase();
